import React from 'react';
import { IConnectedPage } from '../../../types/api/connectedPages/IConnectedPage';

export function ConnectedOrganizationsAndContactPersonsTree({ connectedPages }: { connectedPages: IConnectedPage[] }) {
  return (
    <ol className="eoc__org-tree-table">
      {connectedPages.map((connectedPage) => {
        return (
          <li key={connectedPage.pageId} className="eoc__org-tree-table-li">
            <div className="eoc__org-tree-table-innercontainer">
              <div className="eoc__org-tree-table-column">
                <div className="eoc__org-tree-counter">{connectedPage.pageLink.name}</div>
              </div>
              <div className="eoc__org-tree-table-column">
                {connectedPage.contactPersons && connectedPage.contactPersons.length > 0
                  ? (
                      <>
                        {connectedPage.contactPersons?.map((contactPerson, index, arr) => (
                          <strong className="eoc__org-tree-names" key={contactPerson.profileName}>
                            {contactPerson.profileName}
                            {index < arr.length - 1 ? '; ' : ''}
                          </strong>
                        ))}
                      </>
                    )
                  : null}
              </div>
            </div>
            {connectedPage.childPages && connectedPage.childPages.length > 0
              ? (
                  <ConnectedOrganizationsAndContactPersonsTree connectedPages={connectedPage.childPages} />
                )
              : null}
          </li>
        );
      })}
    </ol>
  );
}
